import React from 'react';
import Tooltip from 'vcomponents/Tooltip';

export interface TableRowProps {
  row;
  onRowClick;
  style?: {};
  cellProps?;
  confirm;
  cancel;
}

const TableRow = ({ row, onRowClick, style: vStyle, cellProps, confirm, cancel }: TableRowProps) => (
  <div
    {...row.getRowProps({
      onClick: () => {
        if (onRowClick) onRowClick(row.original);
      },
      style: vStyle
    })}
    className={`row tr ${onRowClick ? 'clickable' : ''}`}
    // ref={rowRef}
  >
    {row.cells.map((cell) => {
      const {
        column: { type, viewProps = {}, allowTooltip = false, dimKey }
      } = cell;
      const tdCellProps = cell.getCellProps();
      if (dimKey) {
        if (row.original[dimKey]) {
          tdCellProps.style = {
            ...tdCellProps.style,
            background: '#ededed'
          };
        }
      }
      if (allowTooltip) {
        tdCellProps.style = {
          ...tdCellProps.style,
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap'
        };
      }
      if (type === 'number') {
        tdCellProps.style = {
          ...tdCellProps.style,
          textAlign: 'right'
        };
      }
      return (
        <div {...tdCellProps} className="td">
          {allowTooltip ? (
            <Tooltip placement="topLeft" title={cell.value}>
              <span className="td-tooltip">
                {cell.render('Cell', { ...viewProps, ...cellProps, actions: { confirm, cancel } })}
              </span>
            </Tooltip>
          ) : (
            cell.render('Cell', { ...viewProps, ...cellProps, actions: { confirm, cancel } })
          )}
        </div>
      );
    })}
  </div>
);

export default TableRow;
